<template>
    <div class="content-window">
        <div class="news-grid">
            <div class="news-header">
                <div v-html="getText('June 13, 2025: New single out now!')"/> 
            </div>

            <div class="news-cover">
                <img src="AlbumCovers/Only fools can comprehend cover.svg">
            </div>

            <div class="news-stream1">
                <a href="" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Spotify_black.svg"></div>
                        <div v-html="getText(' stream on spotify')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream2">
                <a href="" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/AppleMusic.svg"></div>
                        <div v-html="getText(' stream on Apple Music')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream3">
                <a href="" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Amazon.svg"></div>
                        <div v-html="getText(' stream on Amazon')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream4">
                <a href="" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Youtube.svg"></div>
                        <div v-html="getText(' stream on Youtube Music')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream5">
                <a href="" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Deezer.svg"></div>
                        <div v-html="getText(' stream on Deezer')"/> 
                    </div>
                </a>
            </div>

        </div>

    </div>

</template>

<script>
    import helpers from '../../helpers/helpers.js';

    export default {
        name: 'NewsComponent2',
        data() {
            return {
                buttonClicked: null
            }
        },
        methods: {
            getText(text) {
                return helpers.textToCSV(text);
            },
            clickButton(buttonClicked) {
                this.clickedButton = buttonClicked;
            },
        }
    }
</script>

